import labels from '../../utils/constants/labels';
import ApiValues from '../url/apiurl'
import Networking from '../../utils/api/apiaccess';
var axios = require('axios');

function getFamilyLiquiloansHeader(data) {
    return Networking.PostApi(ApiValues.familyLiquiloansReportHeader, data).then(result => { return result })
        .catch(function (error) {
            return { "status": "F", "message": labels.messages.apierror }
        });
}

export default getFamilyLiquiloansHeader
